// extracted by mini-css-extract-plugin
export default {"option":"SaveCategoryModal_option__HytoD","optionColor":"SaveCategoryModal_optionColor__BBG+O"};